export default __webpack_public_path__ + "static/media/playlist-cover-2.74b128ad.png";